import React, { useState } from "react";
import styles from "./ActiveMessengerContainer.module.scss";
import { AllChatsContainer } from "../AllChatsContainer/AllChatsContainer";
import { AllInfoMessengerContainer } from "../AllInfoMessengerContainer/AllInfoMessengerContainer";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import {
  configureTelegramClient,
  getTelegramIntegration,
} from "../../utils/api/actions/integrations/telegram";
import { ErrorComponent } from "../ErrorComponent/ErrorComponent";
import {
  configureWhatsappClient,
  getWhatsappIntegration,
} from "../../utils/api/actions/integrations/whatsapp";
import { ClipLoader } from "react-spinners";
import {
  setUpdateInst,
  setUpdateTg,
  setUpdateWa,
} from "../../store/slices/integrationSlice";
import { configureInstagramClient, getInstagramIntegration } from "../../utils/api/actions/integrations/instagram";

export const ActiveMessengerContainer = ({ messenger }) => {
  const dispatch = useDispatch();

  const {
    activeTg,
    activeWa,
    activeInst,
    loading,
    updateTg,
    updateWa,
    updateInst,
    updateDataTg,
    updateDataWa,
    updateDataInst,
    errorTg,
    errorWa,
    errorInst,
  } = useSelector((state) => state?.integration);

  const [activeNav, setActiveNav] = useState("all info");

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: <AllInfoMessengerContainer messenger={messenger} />,
    },
    {
      name: "Чаты",
      value: "chats",
      component: <AllChatsContainer />,
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);
    if (activeTg) {
      dispatch(
        getTelegramIntegration(activeTg.userId, activeTg.externalTelegramId)
      );
    } else if (activeWa) {
      dispatch(
        getWhatsappIntegration(activeWa.userId, activeWa.externalWhatsappId)
      );
    } else if (activeInst) {
      dispatch(
        getInstagramIntegration(
          activeInst.userId,
          activeInst.externalInstagramId
        )
      );
    }
  };

  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={`${el.value}-${index}`}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item, index) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null;
      })
      .filter(Boolean);
  };

  const handleCancelEdit = () => {
    if (messenger === "telegram") {
      dispatch(setUpdateTg(false));
    } else if (messenger === "whatsapp") {
      dispatch(setUpdateWa(false));
    } else if (messenger === "instagram") {
      dispatch(setUpdateInst(false));
    }
  };

  const handleSaveUpdatedData = () => {
    if (messenger === "telegram") {
      dispatch(
        configureTelegramClient(updateDataTg, activeTg.externalTelegramId)
      );
    } else if (messenger === "whatsapp") {
      dispatch(
        configureWhatsappClient(updateDataWa, activeWa.externalWhatsappId)
      );
    } else if (messenger === "instagram") {
      dispatch(
        configureInstagramClient(updateDataInst, activeInst.externalInstagramId)
      );
    }
  };

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={handleCancelEdit}
        onSaveUpdatedData={handleSaveUpdatedData}
        isEditing={
          messenger === "telegram"
            ? updateTg
            : messenger === "whatsapp"
            ? updateWa
            : updateInst
        }
        title={"Интеграции"}
        path={"/integration"}
      />

      {errorTg && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных Telegram"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {errorWa && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных WhatsApp"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {errorInst && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных Instagram"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {loading && !errorTg && !errorWa ? (
        <div className={styles.loaderContainer}>
          <ClipLoader color="#3e8fcb" size={90} />
          <div>Загрузка данных</div>
        </div>
      ) : (
        !errorTg &&
        !errorWa && (
          <>
            <div className={styles.navContainer}>
              {renderNavItems(navItems)}
            </div>
            <div className={styles.body}>{renderBodyItems(navItems)}</div>
          </>
        )
      )}
    </div>
  );
};
